import { useIntl } from 'react-intl'

import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import LogoIcon from 'components/App/Header/Logo/LogoIcon'
import Group from 'components/utils/Group'

function TripPlannerMobileHeaderTitle() {
  const intl = useIntl()

  const headerTitleText = intl.formatMessage({
    id: 'VtzmfFKFPBIgcU4-M253',
    defaultMessage: 'TripPlanner',
    description: 'Product name shown in the mobile TripPlanner drawer header',
  })
  const headerSubtitleText = intl.formatMessage({
    id: 'cQNgQNORFaE9uoKLEKbO',
    defaultMessage: 'by Luxury Escapes',
    description: 'Subtitle in the mobile TripPlanner drawer header identifying Luxury Escapes as the brand',
  })

  return (
    <Group direction="horizontal" gap={12} verticalAlign="center">
      <LogoIcon height={40} width={40} mobileVariant="icon" tabletVariant="icon" desktopVariant="icon" />
      <Group direction="vertical">
        <Heading variant="heading4" as="span">
          {headerTitleText}
        </Heading>
        <BodyText variant="small" colour="normal-contrast">
          {headerSubtitleText}
        </BodyText>
      </Group>
    </Group>
  )
}

export default TripPlannerMobileHeaderTitle
